/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import moment from 'moment';
import { DownloadIcon, SearchIcon, SettingsIcon } from '../../../../assets/icons';
import { classNames, Constants, formatMiles, fromStorage, getUpdatedState } from '../../../../utils';
import { Input, Modal, Pagination, Select } from '../../../../components';
import { ReportService } from '../../../../services';
import ModalEvidence from './modal-evidence';

const Failures = ({ tabs }) => {
  const [showDate, setShowDate] = useState(false);
  const [evidenceItem, setEvidenceItem] = useState(null);
  const { data, downloadAll, downloadItem, filters, goToPage, onChange, pagination, reload, search, selects, updateStatus } = useFetchTable();

  const openEvidence = (item) => setEvidenceItem(item);
  const closeEvidence = () => setEvidenceItem(null);

  return (
    <main className="w-full">
      <div className="flex flex-wrap items-end gap-3">
        <Input
          className={{ base: 'max-w-60' }}
          placeholder="Buscar nombre"
          value={filters.search}
          onValueChange={v => onChange('search', v)}
          prepend={
            <img src={SearchIcon} className="w-4 h-4" alt="" />
          }
        />

        <Input
          className={{ base: 'max-w-44' }}
          placeholder="Placa del vehículo"
          value={filters.plaque}
          onValueChange={v => onChange('plaque', v)}
        />

        <Select
          className={{ base: 'max-w-44' }}
          placeholder="Categoría"
          items={selects.categories}
          value={filters.category}
          onValueChange={v => onChange('category', v)}
        />

        <Select
          className={{ base: 'max-w-44' }}
          placeholder="Subcategoría"
          items={selects.subcategories}
          value={filters.subcategory}
          onValueChange={v => onChange('subcategory', v)}
        />

        <Select
          className={{ base: 'max-w-44' }}
          placeholder="Estatus"
          items={selects.status}
          value={filters.status}
          onValueChange={v => onChange('status', v)}
        />

        {showDate && (
          <div className="flex gap-4">
            <Input
              className={{ base: 'max-w-44' }}
              type="date"
              label="Desde"
              value={filters.since}
              onValueChange={v => onChange('since', v)}
            />

            <Input
              className={{ base: 'max-w-44' }}
              type="date"
              label="Hasta"
              value={filters.until}
              onValueChange={v => onChange('until', v)}
            />
          </div>
        )}

        <button
          className={classNames('rounded-full h-10 aspect-square flex items-center justify-center', showDate ? 'bg-orange' : 'bg-white')}
          onClick={() => setShowDate(!showDate)}
        >
          <img src={SettingsIcon} className={classNames('w-5 h-5', showDate ? 'brightness-0 invert' : '')} alt="" />
        </button>

        <div className="flex gap-4">
          <button
            className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
            onClick={search}
          >
            Filtrar
          </button>
          <button
            className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
            onClick={() => reload()}
          >
            Limpiar
          </button>
        </div>
      </div>

      {tabs}

      <div className="bg-white rounded-2xl shadow-md overflow-hidden mt-6">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Historial de Fallas</p>

          <button
            className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-lg font-semibold"
            onClick={() => toast.promise(downloadAll(), { loading: 'Descargando...', success: 'Reporte descargado con éxito', error: 'Error al descargar el reporte' })}
          >
            <img src={DownloadIcon} className="w-4 h-4 brightness-200" alt="" />
            Descargar
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-sm text-default font-semibold align-bottom">
                <th className="pl-4">Placa vehículo</th>
                <th>Conductor</th>
                <th>Fecha de la falla</th>
                <th>Kilometraje actual</th>
                <th>Categoría</th>
                <th>Subcategoría</th>
                <th>Motivo de servicio</th>
                <th>Evidencia</th>
                <th>Estatus</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item) => (
                <tr key={item.id} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <td>
                    <Link to={`/report/failures/${item?.vehicle?.plaque}`}>
                      <span className="pl-4 text-orange font-semibold text-base">{ item?.vehicle?.plaque }</span>
                    </Link>
                  </td>
                  <td>{ item?.driver?.person?.fullName }</td>
                  <td>{ moment(item?.date).format('DD/MM/YYYY') }</td>
                  <td>{ formatMiles(item?.mileage, false, '') }</td>
                  <td>{ item?.category?.name }</td>
                  <td>{ item?.subcategory?.name }</td>
                  <td>{ item?.reason }</td>
                  <td>
                    <span
                      className="text-white bg-black rounded-full px-2 py-1 cursor-pointer"
                      onClick={() => openEvidence(item)}
                    >
                      Ver
                    </span>
                  </td>
                  <td>
                    {item.status === Constants.VEHICLE_FAILURE.STATUS.PENDING ? (
                      <span
                        className="text-white bg-red rounded-full px-2 py-1 cursor-pointer"
                        onClick={() => updateStatus(item.id, Constants.VEHICLE_FAILURE.STATUS.RESOLVED)}
                      >
                        { item.status_text }
                      </span>
                    ) : (
                      <span className="text-text">{ item.status_text }</span>
                    )}
                  </td>
                  <td>
                    <img
                      src={DownloadIcon}
                      className="w-5 h-5 object-contain cursor-pointer"
                      onClick={() => {
                        toast.promise(downloadItem(item.id), {
                          loading: 'Descargando...',
                          success: 'Reporte descargado con éxito',
                          error: 'Error al descargar el reporte',
                        })
                      }}
                      alt=""
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>

      <Modal isOpen={!!evidenceItem} onClose={closeEvidence}>
        {evidenceItem && (
          <ModalEvidence item={evidenceItem} onClose={closeEvidence} />
        )}
      </Modal>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    plaque: '',
    category: '',
    subcategory: '',
    status: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [selects, setSelects] = useState({
    categories: [],
    subcategories: [],
    allSubcategories: [],
    status: [],
  });

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await ReportService.owner.failures.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const getSelects = async () => {
    const format = (items) => items?.map(x => ({ value: x.id, label: x.name })) || [];

    try {
      const response = await ReportService.owner.failures.getSelects();
      setSelects({
        categories: format(response.categories),
        allSubcategories: response.subcategories,
        subcategories: [],
        status: format(response.status),
      });

    } catch (error) {
      setSelects({
        categories: [],
        allSubcategories: [],
        subcategories: [],
        status: [],
      });
      toast.error(String(error));
    }
  }

  const downloadAll = async () => {
    try {
      const response = await ReportService.owner.failures.downloadAll(filters);
      if (response.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const downloadItem = async (id) => {
    try {
      const response = await ReportService.owner.failures.downloadOne(id);
      if (response.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
    if (target === 'category') {
      setFilters(s => ({ ...s, subcategory: '' }));
      setSelects(s => ({
        ...s,
        subcategories: s.allSubcategories
          ?.filter(x => x.failure_category_id === +value)
          ?.map(x => ({ value: x.id, label: x.name })) || [],
      }));
    }
  }

  useEffect(() => {
    fetchData();
    getSelects();
  }, []);

  return {
    data,
    downloadAll,
    downloadItem,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
    selects,
  }
}

export default Failures;